window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.swiperJs, {
        defer: true,
        onload: () => window.cpap.createAndDispatchGlobalEvent('swiperReady'),
      });

      const instantiatePlpMostPopularSwiper = () => {
        new window.Swiper('.cpap__plp-best-sellers__carousel--most-popular', {
          slidesPerView: 1,
          pagination: {
            el: '.cpap__plp-best-sellers__carousel--most-popular .swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.cpap__plp-best-sellers__carousel--most-popular .swiper-button-next',
            prevEl: '.cpap__plp-best-sellers__carousel--most-popular .swiper-button-prev',
          },
          breakpoints: {
            556: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          },
        });
      };

      window.cpap.waitForVariableAndDomReady('Swiper', instantiatePlpMostPopularSwiper);
    },
    { priority: 'user-blocking' }
  );
});
